import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData, infoStdData, infoClassData } from "./infoenum";

class PoeResult extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      result,
      subtest,
      subtestPoeResults,
      translate,
      chartMeasurementUnit
    } = this.props;

    return subtestPoeResults && subtestPoeResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={4}></Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_started")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestPoeResults.teststarted
                  ? moment(subtestPoeResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.totalGridLast}>
              <Typography
                className={classes.defaultText}
                style={{ marginLeft: "15px" }}
                color="inherit"
              >
                {translate("result_info_status")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {subtestPoeResults.subteststatus &&
                    subtestPoeResults.subteststatus.toLowerCase() ==
                      "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}

                    {subtestPoeResults.info &&
                    infoData.find(o => o.name === subtestPoeResults.info) ? (
                      <Typography className={classes.statusText}>
                        {" " +
                          translate(
                            infoData.find(
                              o => o.name === subtestPoeResults.info
                            ).id
                          )}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>

          <Grid container>
            <Grid item xs={4}></Grid>
            <Grid item xs={4}>
              <div className={classes.div_table1}>
                {subtestPoeResults && (
                  <Table className={classes.table}>
                    {/* <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableheader_first}>
                        {translate("general_pairs")}
                      </TableCell>
                      <TableCell className={classes.tableheader_first}>
                        {translate("test_length")}
                      </TableCell>
                    </TableRow>
                  </TableHead> */}
                    <TableBody>
                      <TableRow>
                        <TableCell className={classes.tablecontent_first}>
                          {translate("poestd") + ":"}
                        </TableCell>
                        <TableCell className={classes.tablecontent_first}>
                          {subtestPoeResults.poestd &&
                          infoStdData.find(
                            o => o.name === subtestPoeResults.poestd
                          )
                            ? translate(
                                infoStdData.find(
                                  o => o.name === subtestPoeResults.poestd
                                ).id
                              )
                            : ""}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tablecontent_first}>
                          {translate("poeclass") + ":"}
                        </TableCell>
                        <TableCell className={classes.tablecontent_first}>
                          {subtestPoeResults.poeclass &&
                          infoClassData.find(
                            o => o.name === subtestPoeResults.poeclass
                          )
                            ? translate(
                                infoClassData.find(
                                  o => o.name === subtestPoeResults.poeclass
                                ).id
                              )
                            : ""}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tablecontent_first}>
                          {translate("power") + ":"}
                        </TableCell>
                        <TableCell className={classes.tablecontent_first}>
                          {subtestPoeResults.power &&
                            subtestPoeResults.power.toFixed(2)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.tablecontent_first}>
                          {translate("voltage") + ":"}
                        </TableCell>
                        <TableCell className={classes.tablecontent_first}>
                          {subtestPoeResults.voltage &&
                            subtestPoeResults.voltage.toFixed(2)}
                        </TableCell>
                      </TableRow>
                      {/*<TableRow>
                        <TableCell className={classes.tablecontent_first}>
                          {translate("maxpowerloss") + ":"}
                        </TableCell>
                        <TableCell className={classes.tablecontent_first}>
                          {subtestPoeResults.maxpowerloss && (subtestPoeResults.maxpowerloss > 0) ? subtestPoeResults.maxpowerloss.toFixed(2) : "-"}
                        </TableCell>
                          </TableRow>*/}
                      {/* <TableRow>
                        <TableCell className={classes.tablecontent_first}>
                          {translate("current") + ":"}
                        </TableCell>
                        <TableCell className={classes.tablecontent_first}>
                          {subtestPoeResults.current &&
                            subtestPoeResults.current}
                        </TableCell>
                      </TableRow> */}
                    </TableBody>
                  </Table>
                )}
              </div>
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const { getsubtestPoeResults, subtest, pager } = this.props;

    getsubtestPoeResults(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const { getsubtestPoeResults, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getsubtestPoeResults(pager.jid, pager.tid, subtest, null);
    }
  }
}

export default withStyles(styles)(PoeResult);
